import { AddExistingPoint, AddTrace, AddTraceGPX, CalcItineraire, CenterMapFromListTrace, DeleteTrace, markerSVG } from "../Util/ActivitesUtil";
import { HistoryAction } from "./historyManager";

export interface OneValueItinerairetAction extends HistoryAction {
    type: "color_itineraire";
    target: "marker-color" | "label-color" | "trace-color" | "marker-size" | "label-size" | "trace-size" | "trace-pointille" | "label-position" |
    "marker-item" | "write-label" | "marker-visible" | "gpx-visible" | "map-style" | "marker-font" | "marker-contour" | "marker-contour-color";
    item: any;
    from: any;
    to: any;
}

export function createOneValueItinerairetAction(
    params: {
        target: OneValueItinerairetAction["target"];
        item: any;
        from: any;
        to: any;
    }
): OneValueItinerairetAction {

    //le context en une ref du composant AbsoluteMenuSection
    //si on le ferme et que l'on ouvre à nouveau, et qu'on fait back, les valuers n'y pas mise à jour
    //il faut que les fonction type setSizeMarker soit stocké dans le context global de l'app..

    const { target, item, from, to } = params;

    var map = (window as any).$map;
    var l = map.getStyle().layers;

    function applyValue(value: any) {
        if (target === "marker-color") {
            var itemMakerDivSvg = item.marker.getElement().querySelector('div').querySelector('svg');
            var itemMakerDivDiv = item.marker.getElement().querySelector('div').querySelector('div');

            item.markerStyle.color = value;
            if (itemMakerDivDiv != null) itemMakerDivDiv.style.backgroundColor = value;
            else itemMakerDivSvg.style.fill = value;
        }
        else if (target === "label-color") {
            var itemMakerLabel = item.markerTxt.getElement();

            item.markerTxtStyle.color = value;
            itemMakerLabel.style.color = value;
        }
        else if (target === "trace-color") {
            item.traceStyle["line-color"] = value;

            const myLayers = l.filter((x: any) => x.id === item.id);

            myLayers.forEach((element: any) => {
                map.setPaintProperty(element.id, "line-color", value)
            });
        }
        else if (target === "marker-size") {
            let itemMakerDiv = item.marker.getElement().querySelector('div');

            item.markerStyle.size = value;
            itemMakerDiv.style.width = value + 'px';
            itemMakerDiv.style.height = value + 'px';
        }
        else if (target === "label-size") {
            var itemMakerTxt = item.markerTxt.getElement();
            item.markerTxtStyle.size = value;
            itemMakerTxt.style['font-size'] = value + 'px';

        }
        else if (target === "trace-size") {

            item.traceStyle["line-width"] = value;

            const myLayers = l.filter((x: any) => x.id === item.id);

            myLayers.forEach((element: any) => {
                map.setPaintProperty(element.id, "line-width", value)
            });
        }

        else if (target === "trace-pointille") {

            item.traceStyle["line-dasharray"] = value;

            const myLayers = l.filter((x: any) => x.id === item.id);

            myLayers.forEach((element: any) => {
                map.setPaintProperty(element.id, "line-dasharray", value)
            });
        }
        else if (target === "label-position") {

            item.markerTxt._anchor = value;
            item.labelPosition = value;
            item.markerTxt._update();
        }

        else if (target === "marker-item") {
            let itemMakerDiv = item.marker.getElement().querySelector('div');

            itemMakerDiv.innerHTML = markerSVG(value, item.markerStyle.color);

            //Dès qu'on change de marker, on set la taille à 100 pixel pour qu'il apparaisse plus
            if (value !== 'marker-circle') {
                item.markerStyle.size = 100;
                itemMakerDiv.style.width = '100px';
                itemMakerDiv.style.height = '100px';
            }
            else {
                item.markerStyle.size = 50;
                itemMakerDiv.style.width = '50px';
                itemMakerDiv.style.height = '50px';
            }

            item.markerStyle.class = value;
            item.markerType = value;
        }
        else if (target === "marker-visible") {

            if (!value) {
                item.marker.getElement().style.visibility = 'hidden';
                item.markerTxt.getElement().style.visibility = 'hidden';
                item.visible = false;
            }
            else {
                item.marker.getElement().style.visibility = 'visible';
                item.markerTxt.getElement().style.visibility = 'visible';
                item.visible = true;
            }
        }
        else if (target === "marker-font") {

            var itemMakerLabel = item.markerTxt.getElement();
            item.markerTxtStyle.fontFamily = value;
            itemMakerLabel.style.fontFamily = value;
            item.markerTxt._update();
        }
        else if (target === "marker-contour") {
            var itemMakerLabel = item.markerTxt.getElement();
            item.markerTxtStyle['-webkit-text-stroke-width'] = value; 
            itemMakerLabel.style['-webkit-text-stroke-width'] = value;
            item.markerTxt._update();
        }


        //"marker-font" | "marker-contour" | "marker-contour-color"

    }

    return {
        type: "color_itineraire",
        target,
        item,
        from,
        to,

        undo() {
            applyValue(from);
        },

        redo() {
            applyValue(to);
        }
    };
}

export interface OneValueAndContextItinerairetAction extends OneValueItinerairetAction {
    context?: any;
}

export function createOneValueAndContextItinerairetAction(
    params: {
        target: OneValueItinerairetAction["target"];
        item: any;
        from: any;
        to: any;
        context: any;
    }
): OneValueAndContextItinerairetAction {

    //le context en une ref du composant AbsoluteMenuSection
    //si on le ferme et que l'on ouvre à nouveau, et qu'on fait back, les valuers n'y pas mise à jour
    //il faut que les fonction type setSizeMarker soit stocké dans le context global de l'app..

    const { target, item, from, to, context } = params;

    function applyValueContext(value: any) {

        var map = (window as any).$map;
        var l = map.getStyle().layers

        if (target === "write-label") {
            item.markerTxt.getElement().textContent = value;
            item.label = value;
            context.setLabel(value)
        }
        else if (target === "gpx-visible") {

            const myLayers = l.filter((x: any) => x.id === item.id);

            if (!value) {
                item.visible = false;

                myLayers.forEach((element: any) => {
                    map.setLayoutProperty(element.id, 'visibility', 'none');
                });

                context.setIsTraceVisible(false);
            }
            else {
                item.visible = true;

                myLayers.forEach((element: any) => {
                    map.setLayoutProperty(element.id, 'visibility', 'visible');
                });

                context.setIsTraceVisible(true);
            }
        }
        else if (target === "map-style") {

            map.setStyle(value);

            if (context.setMapUrlStyle != null) context.setMapUrlStyle(value)

            setTimeout(() => {
                context.addSourcesAndLayers();

            }, 1500);
        }
    }

    return {
        type: "color_itineraire",
        target,
        item,
        from,
        to,
        context,

        undo() {
            applyValueContext(from);
        },

        redo() {
            applyValueContext(to);
        }
    };
}

/* Points et Traces*/

export interface TraceAndPointAction extends HistoryAction {
    type: "add_pointAndTrace";
    target: "add_point" | "add_trace" | "delete_point";
    snapshotMapListPoint: any;
    snapshotMapListTrace: any;
    item: any;
    context: any;
}

export function createPointAndTraceItinerairetAction(
    params: {
        target: TraceAndPointAction["target"];
        item: any;
        snapshotMapListPoint: any;
        snapshotMapListTrace: any;
        context: any;
    }
): TraceAndPointAction {

    //le context en une ref du composant AbsoluteMenuSection
    //si on le ferme et que l'on ouvre à nouveau, et qu'on fait back, les valuers n'y pas mise à jour
    //il faut que les fonction type setSizeMarker soit stocké dans le context global de l'app..

    const { target, item, snapshotMapListPoint, snapshotMapListTrace, context } = params;

    return {
        type: "add_pointAndTrace",
        target,
        item,
        snapshotMapListPoint,
        snapshotMapListTrace,
        context,

        undo() {
            DeleteTrace(item, true, context)
        },

        redo() {
            //add point last point (le redo de add Point remet le dernier point)
            var newPoint = AddExistingPoint(item, true, context)
            if (context.addMapListPoint != null) context.addMapListPoint([newPoint]);

            if (context.mapListPoint.length > 0) {
                //avec le point position
                CalcItineraire(context.mapListPoint[context.mapListPoint.length - 1], newPoint, "driving", null, null, context)
            }
        }
    };
}

export function deletePointAndTraceItinerairetAction(
    params: {
        target: TraceAndPointAction["target"];
        item: any;
        snapshotMapListPoint: any;
        snapshotMapListTrace: any;
        context: any;
    }
): TraceAndPointAction {

    //le context en une ref du composant AbsoluteMenuSection
    //si on le ferme et que l'on ouvre à nouveau, et qu'on fait back, les valuers n'y pas mise à jour
    //il faut que les fonction type setSizeMarker soit stocké dans le context global de l'app..

    const { target, item, snapshotMapListPoint, snapshotMapListTrace, context } = params;

    return {
        type: "add_pointAndTrace",
        target,
        item,
        snapshotMapListPoint, snapshotMapListTrace,
        context,

        undo() {

            //undo of deleting a point
            //alogrithm is difficult to handle point suppression, peut etre au milieu de 2 tracé, compliqué à recréer, doit gérer trop de cas
            //solution : supprimer tous les points et tracés, 
            //et recréer selon les points et tracés stocké au moment du delete
            //performances très rapide, on valide

            //context.getMapListPoint() => list actuel de point
            //DeleteTrace supprime les points et les tracé associé, avec false en param, on évite de recréer des itinéraires après suppression de points
            context.getMapListPoint().forEach((element: any) => {
                DeleteTrace(element, false, context)
            });

            //on rejoue toute la création des tracés
            var f = context.addMapListPoint;

            const copyItemsPoint: any[] = [];
            snapshotMapListPoint.forEach((element: any) => {
                var newPoint = AddExistingPoint(element, false, { snapshotMapListPoint, f });
                copyItemsPoint.push(newPoint);
            });

            if (context.setMapListPoint != null) context.setMapListPoint(copyItemsPoint);

            //Gestion des tracés
            const copyItemsTrace: any[] = [];
            snapshotMapListTrace.forEach((element: any) => {
                var newTrace = AddTrace(element.name, element.sourceData, element.sourceData, element.type, element.point1, element.point2, element.id, element.traceStyle,
                    context);

                copyItemsTrace.push(newTrace)
            });

            if (context.setMapListTrace != null) context.setMapListTrace(copyItemsTrace);
            //CenterMapFromListTrace(copyItemsTrace, context.mapLock);
            setTimeout(() => {
                //CenterMapFromListTrace est appelé à chaque deleteTrace, on attend que ça soit fait pour le faire à nouveau
                CenterMapFromListTrace(copyItemsTrace, context.mapLock);
            }, 100);

        },

        redo() {
            //add point
            DeleteTrace(item, true, context)

        }
    };
}

//GPX add undo/redo
export interface GPXAction extends HistoryAction {
    type: "add_gpx";
    point1: any, point2: any, route: any, sourceData: any, typeTransport: String, depart: any, arrivee: any, context: any
}

export function createTraceGPXItinerairetAction(
    params: {
        point1: any, point2: any, route: any, sourceData: any, typeTransport: String, depart: any, arrivee: any, context: any
    }
): GPXAction {


    const { point1, point2, route, sourceData, typeTransport, depart, arrivee, context } = params;

    return {
        type: "add_gpx",
        point1, point2, route, sourceData, typeTransport, depart, arrivee, context,
        undo() {
            DeleteTrace(point1, true, context)
        },

        redo() {
            AddTraceGPX("GPX", route, sourceData, typeTransport, depart, arrivee, point1.id, point2.id, context)
        }
    };
}

//GPX add undo/redo
export interface TransportAction extends HistoryAction {
    type: "change_transport";
    point1: any;
    point2: any;
    trace: any;
    from: any;
    to: any;
    context: any;
}

export function selectTransportItinerairetAction(
    params: {
        point1: any;
        point2: any;
        trace: any;
        from: any;
        to: any;
        context: any;
    }
): TransportAction {


    const { point1, point2, trace, from, to, context } = params;

    return {
        type: "change_transport",
        point1, point2, trace, from, to, context,
        undo() {
            if (from === 'none') {
                trace.type = 'none';
            }
            else {
                CalcItineraire(point1, point2, from, trace, null,
                    context)
            }
        },

        redo() {
            if (to === 'none') {
                trace.type = 'none';
            }
            else {
                CalcItineraire(point1, point2, to, trace, null,
                    context)
            }
        }
    };
}